import type { FilterForm } from '../../types'
import type { Step } from './types'

export const extractWellIdsContext = (activeStep: Step) =>
  activeStep.id === 'applyVsp' ? activeStep.context : undefined

export const extractWellIdContext = (activeStep: Step) =>
  activeStep.id === 'wellVspSettings' || activeStep.id === 'chooseVsp'
    ? activeStep.context
    : undefined

export const extractFilterFormContext = (activeStep: Step): FilterForm | undefined =>
  activeStep.id === 'chooseBaseWell' ||
  activeStep.id === 'chooseWellWithVsp' ||
  activeStep.id === 'chooseTargetWells'
    ? activeStep.context
    : undefined

export const extractVspIdContext = (activeStep: Step) =>
  activeStep.id === 'chooseTargetWells' ? activeStep.context?.vspId : undefined
